




























import {Component, Prop, Vue} from 'vue-property-decorator';
import StInput2 from '@/components/basic/StInput2.vue';
import {TimeAccountTeamWeeklyOverviewWeekModel, TimeAccountWeekOvertimeApproveCommand} from '@/services/api/nswag/stapiclient_generated';
import {stTimeAccountApi} from '@/services/st-api';

@Component({
  components: { StInput2 },
})
export default class TeamOverviewTimeAccountApprovalForm extends Vue {
  @Prop() week!: TimeAccountTeamWeeklyOverviewWeekModel;
  @Prop() appUserId!: number;

  command: TimeAccountWeekOvertimeApproveCommand = TimeAccountWeekOvertimeApproveCommand.fromJS({comment: ''});

  popOverOpen: boolean = false;
  loading: boolean = false;

  async openPopover() {
    this.popOverOpen = true;
    this.command = TimeAccountWeekOvertimeApproveCommand.fromJS({});
    this.command.comment = this.week.overtimeIsApprovedComment;
    this.command.weekStartDate = this.week.dateFrom;
    this.command.appUserId = this.appUserId;
  }

  async approve() {
    await stTimeAccountApi.approveOverTimeWeek(this.command);
    this.popOverOpen = false;
    this.$emit('timeapproved');
  }

  cancel() {
    this.popOverOpen =false;
  }

  getApprovalTooltip(model: TimeAccountTeamWeeklyOverviewWeekModel) {
    let toolTipText = '';

    if (model.overtimeIsApproved)
    {
      toolTipText = '<div>Überstunden sind genehmigt</div>';
      if (model.overtimeIsApprovedComment)
      {
        toolTipText+='<div class="font-bold">Kommentar:</div><div>' + model.overtimeIsApprovedComment + '</div>';
      }
    }

    if (model.displayOvertimeIsNotApprovedWarning)
    {
      toolTipText = '<div>Überstunden sind nicht genehmigt</div>';
    }

    return {
      content: toolTipText,
      isHtml: true,
    };
  }
}

